var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 607,
    height: 427,
    viewBox: "0 0 607 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7168 50.2328L179.407 17.6469L237.407 29.6469L463.344 250.339L398.907 250.339L226.297 395.572L14.7168 50.2328Z",
    fill: "#B6EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.907 21.1469L324.907 10.1469L401.407 28.6469L598.407 178.647L507.407 204.647L475.282 243.025L249.907 21.1469Z",
    fill: "#B6EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.225 407.594L407.06 254.833L468.176 259.044L468.176 282.147L228.225 426.147L228.225 407.594Z",
    fill: "#4A738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.407 185.147L511.907 213.147L485.407 248.647L502.907 260.147L599.407 201.647L599.407 185.147Z",
    fill: "#4A738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9065 100.647L14.2548 54.6469L220.406 402.147L220.406 433.147L22.9065 100.647Z",
    fill: "#4A738C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.407 28.4269L312.407 15.1469L504.907 204.647L470.407 244.647L242.407 28.4269Z",
    fill: "#AAC4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4067 53.1469L173.407 25.1469L362.407 261.647L231.907 374.147L29.4067 53.1469Z",
    fill: "#AAC4CC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 606,
    height: 426,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 607,
    height: 427,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.c6bf1ecec42a1e36e194072c32199cdb.svg";
export { ForwardRef as ReactComponent };